/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Empty_TitleInputs */

const en_us2_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole app, in one place`)
};

const pt_br2_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo do app, num lugar só`)
};

const es_419_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda la app, en un solo lugar`)
};

const pt_pt2_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A app inteira, num só lugar`)
};

const fr_fr2_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute l'app, au même endroit`)
};

const de_de2_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die ganze App an einem Ort`)
};

const it_it2_search_preview_empty_title = /** @type {(inputs: Search_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutta l'app, in un unico posto`)
};

/**
* | output |
* | --- |
* | "The whole app, in one place" |
*
* @param {Search_Preview_Empty_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_empty_title = /** @type {((inputs?: Search_Preview_Empty_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Empty_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_empty_title(inputs)
	if (locale === "es-419") return es_419_search_preview_empty_title(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_empty_title(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_empty_title(inputs)
	if (locale === "de-DE") return de_de2_search_preview_empty_title(inputs)
	if (locale === "it-IT") return it_it2_search_preview_empty_title(inputs)
	return en_us2_search_preview_empty_title(inputs)
});
export { search_preview_empty_title as "search.preview_empty_title" }